import React from 'react';
import {Badge} from '../ui';
import Label from "../Label/Label";

interface IExtraLabelsProps {
	labels: Array<string>,
}

function ExtraLabels({labels}: IExtraLabelsProps) {
	return (
		<Badge pill bg="primary" className="label mr-1 mb-2" title={labels.join(', ')}>
			<span>+{labels.length}</span>
		</Badge>
	);
}

interface IProps {
	labels: Array<string>,
	maxCharacterCount?: number
}

function Labels({labels = [], maxCharacterCount}: IProps) {
	const getTotalLength = (labels: Array<string>) => labels.reduce((acc, curr) => acc + curr.length, 0);
	const getDisplayText = (label: string) =>
		maxCharacterCount && label.length > maxCharacterCount ? label.substring(0, maxCharacterCount) + "..." : label;

	const sortedLabels = [...labels].sort((a, b) => a.length - b.length);
	let displayLabels = sortedLabels;
	if (maxCharacterCount && getTotalLength(labels) > maxCharacterCount)
		displayLabels = displayLabels.reduce((acc, curr, i) =>
			i === 0 || getTotalLength([...acc, curr]) <= maxCharacterCount ?
				[...acc, curr] :
				acc, [] as Array<string>
		);
	const extraLabels = sortedLabels.filter(l => !displayLabels.includes(l));
	return (
		<div className="labels">
			{
				displayLabels.map(l =>
					<span key={l} title={l}>
						<Label value={getDisplayText(l)}/>
					</span>
				)
			}
			{
				extraLabels.length > 0 && <ExtraLabels labels={extraLabels}/>
			}
		</div>
	);
}

export default Labels;
